export enum PaymentMethod {
  PAYPAL = 'paypal',
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  APPLE_PAY = 'applePay',
  KLARNA = 'klarna',
  TWINT = 'twint',
  IDEAL = 'ideal',
}

export const COMMON_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.PAYPAL,
  PaymentMethod.VISA,
  PaymentMethod.MASTERCARD,
  PaymentMethod.AMEX,
  PaymentMethod.APPLE_PAY,
];
